import {
  makeStyles,
  shorthands,
} from '@fluentui/react-components';

export const useStyles = makeStyles({
  dialogSurface: {
    maxWidth: '600px',
    minWidth: '500px',
  },
  dialogContent: {
    ...shorthands.padding('10px', '0', '20px', '0'),
  },
  description: {
    fontSize: '14px',
    lineHeight: '20px',
    marginBottom: '20px',
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',

    '& .fui-Radio label': {
      paddingTop: '5px',
      paddingBottom: '5px',
    },
  },
  radioButton: {
    fontSize: '14px',
  },
  buttonSpacing: {
    marginLeft: '8px',
  },
  emailContainer: {
    width: '90%',
    paddingLeft: '36px',

    '& input': {
      border: 'none',
    },

    '& input:hover': {
      border: 'none',
    },

    '& input:focus': {
      border: 'none',
    },


    '& label': {
      fontSize: '14px',
      fontWeight: 400,
    },
  },
  serverErrorMessage: {
    paddingLeft: '12px',
    marginTop: '8px',
  },
});
